import { useEffect, useState, useCallback } from "react";
import { FileSignature } from "lucide-react";
import { PortalLayout } from "../../components/PortalLayout";
import { UploadTile } from "../../components/UploadTile";
import { api } from "../../lib/api";

export default function CandidateDocuments() {
  const [docs, setDocs] = useState([]);
  const [consents, setConsents] = useState([]);

  const load = useCallback(() => {
    api.get("/documents").then((r) => setDocs(r.data)).catch(() => {});
    api.get("/consent").then((r) => setConsents(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <PortalLayout>
      <div data-testid="candidate-documents-page">
        <p className="text-xs uppercase tracking-[0.25em] text-[#7C8514] font-medium">Upload centre</p>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0d2f4d] tracking-tight mt-2">My documents</h1>
        <p className="text-sm text-[#51637a] mt-1">Keep everything current — recruiters review these before shortlisting you.</p>

        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          <UploadTile docType="cv" label="CV / Resume" hint="PDF, DOCX or TXT" accept=".pdf,.docx,.txt" existingDocs={docs} onChange={load} />
          <UploadTile docType="photo" label="Profile photo" hint="JPG or PNG" accept="image/*" existingDocs={docs} onChange={load} />
          <UploadTile docType="credentials" label="Credentials" hint="Certificates, licences, tickets" existingDocs={docs} onChange={load} />
          <UploadTile docType="references" label="References" hint="Written references or referee contacts" existingDocs={docs} onChange={load} />
          <UploadTile docType="id" label="Photo ID" hint="Passport or driver licence" existingDocs={docs} onChange={load} />
          <UploadTile docType="police_check" label="Police check" hint="If available" existingDocs={docs} onChange={load} />
        </div>

        <div className="ditch-card p-6 mt-6" data-testid="consent-status-card">
          <h2 className="font-heading font-bold text-[#0d2f4d] flex items-center gap-2"><FileSignature size={18} /> Consent status</h2>
          {consents.length === 0 ? (
            <p className="text-sm text-[#51637a] mt-3">Not yet signed. Complete the consent step in <span className="font-medium">My Profile → Consent & submit</span>.</p>
          ) : (
            <ul className="mt-3 space-y-2">
              {consents.map((c) => (
                <li key={c.id} className="text-sm text-[#122c47]">
                  ✓ {c.document_name} — signed by <strong>{c.typed_signature}</strong> on {new Date(c.signed_at).toLocaleString()}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </PortalLayout>
  );
}
